import React, { Component } from 'react';

import CommonPropTypes from '../../../app/constants/PropTypes';
import ErrorPage from '../ErrorPage';

import ErrorWindow from './ErrorWindow.svg';

export default class NotFound extends Component {
  static propTypes = {
    homeLink: CommonPropTypes.link.isRequired,
    history: CommonPropTypes.history,
  };

  render() {
    return (
      <ErrorPage
        homeLink={this.props.homeLink}
        heading="Looks like you took a wrong turn"
        image={ErrorWindow}
        primaryMessage="This page does not exist"
        statusCode={404}
        supportMessage="if you think this page should be here"
        title="Page not found"
      />
    );
  }
}
